import { Modal, ModalId } from "../../../../features/ui"
import { TableName } from "../../../../tables"
import { define } from "../../../../utils/typeUtils"
import { Operation } from "../../state/types"
import { useActions } from "./actions"

type Props = {
    table: TableName
    operation?: Operation
}

export const CloseOperationModal = (props: Props) => {
    const { table, operation } = props
    const { getOperationLabel, closeOperation } = useActions()

    const title = `Cerrar operación?`

    const renderBody = () => operation ? 
        `Esta acción actualizará ${getOperationLabel(table, operation)} con estado "Entregado". Desea confirmar el cierre?` :
        <></>

    const onClose = () => closeOperation(table, define(operation))

    return (
        <Modal
            modalId={ModalId.CLOSE_OPERATION}
            title={title}
            submitLabel="Confirmar"
            onSubmit={onClose}
        >
            <>{renderBody()}</>
        </Modal>
    )
}
